import CustomFieldProto from '../../proto/custom-field-proto';
import ListComponent from './components/list-list';
import ListGroupHeaderComponent from "./components/list-group-list-header";
import ViewComponent from './components/list-view';
import EditComponent from './components/edit';
import FormComponent from "./components/form";
import FormNewComponent from './components/list-form-new';
import FieldDropdownViewInImport from "./components/view-in-preview";

export default class ListMultiCustomField extends CustomFieldProto {

    constructor(customField) {
        super(customField);
    }

    getValueById(id) {
        const option = _.find(this.customField.params.listItems, (option) => option.id === id);
        return option ? option.value : null;
    }

    getCsvValue(item) {
        const { customFieldsData } = item;
        let res = [];
        if (!!customFieldsData[this.customField.id]) {
            customFieldsData[this.customField.id].map(v=>{
                const option = _.find(this.customField.params.listItems, li => li.id === v);
                if (option) res.push(option.value);
            });
        }
        return res.join(', ');
    }

    /*listItemGroupFunction() {
        return i=>i.item.customFieldsData[this.customField.id] ? i.item.customFieldsData[this.customField.id] : null;
    }*/

    listItemSortFunctions(sort) {
        return {
            functions: [
                i => !!sort ? 0 : !!i.item.customFieldsData[this.customField.id] ? 1 : 2,
                i => {
                    if (!(this.customField.id in i.item.customFieldsData)) return 0;
                    if (!this.customField.params || !this.customField.params.listItems || this.customField.params.listItems.length < 2) return 0;

                    const value = i.item.customFieldsData ? i.item.customFieldsData[this.customField.id] : -1;

                    let optionIdxPlus1 = 1;
                    this.customField.params.listItems.some(li => {
                        if (li.id === value) {
                            return true;
                        }
                        optionIdxPlus1++;
                    });

                    return optionIdxPlus1;
                }
            ],
            directions: ['asc', sort]
        }
    }

    get EditComponent() {
        return EditComponent.bind(null, this.customField.id);
    }

    get ListComponent() {
        return ListComponent.bind(null, this.customField.id);
    }

    get ListGroupHeaderComponent() {
        return ListGroupHeaderComponent.bind(null, this.customField.id);
    }

    get ViewComponent() {
        return ViewComponent.bind(null, this.customField.id);
    }

    get FormAddComponent() {
        return FormComponent;
    }

    get FormNewComponent() {
        return FormNewComponent.bind(null, this.customField.id);
    }

    // IMPORT

    normalizeCSVValue(values) {
        let selectedValues = values ? values.split(', ') : [];
        selectedValues = _.map(selectedValues, value=>value.toLowerCase())

        const ids = [];
        _.map(selectedValues, value=>{
            const preparedValue = value.toLowerCase();
            const option = _.find(this.customField.params.listItems, li => preparedValue === li.value.toLowerCase());
            if (option) ids.push(option.id);
        })

        return ids;
    }

    getComponentViewInImport() {
        return FieldDropdownViewInImport.bind(null, this); // this = custom field object
    }
}